import { render } from "./create_case.html?vue&type=template&id=2ab3316f&external"
import script from "./create_case.js?vue&type=script&lang=js&external"
export * from "./create_case.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__